export default "__VITE_ASSET__BrjhVyrT__"